import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import Spinner from "react-activity/dist/Spinner";
import tanuragalogo from "../assets/images/tanuraga-logo.png";
import { apiUrl } from '../config/Config';

const SubmitOtpPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || sessionStorage.getItem('passwordResetEmail') || "";
  const [otp, setotp] = useState("");
  const [showloding, setshowloding] = useState(false);

  const handleSubmit = async(e) => {
    e.preventDefault();

    if (!email) {
      navigate('/forgot-password', { replace: true });
      return;
    }

    if (!otp) {
      Swal.fire({
        title: '',
        text: 'OTP is required',
        icon: 'error',
        width: '350px',
        confirmButtonText: 'Ok',
        confirmButtonColor: "rgb(59, 151, 196)",
        customClass: {
          popup: "small-icon-alert",
        },
      });
      return;
    }

    setshowloding(true);
    const headers = {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      }
    };

    await axios.post(apiUrl + 'customerverifyotp', { email, otp }, headers).then((res) => {
      if(res.data.status === 'success') {
        sessionStorage.setItem('passwordResetEmail', email);
        Swal.fire({
          title: '',
          text: res.data.message,
          icon: 'success',
          width: '350px',
          confirmButtonText: 'Ok',
          confirmButtonColor: "rgb(59, 151, 196)",
          customClass: {
            popup: "small-icon-alert",
          },
        });
        navigate('/reset-password', { state: { email } });
      } else {
        Swal.fire({
          title: '',
          text: res.data.message,
          icon: 'error',
          width: '350px',
          confirmButtonText: 'Ok',
          confirmButtonColor: "rgb(59, 151, 196)",
          customClass: {
            popup: "small-icon-alert",
          },
        });
      }
    }).catch((err) => {
      alert(err.message);
    });
    setshowloding(false);
  };

  return (
    <div className="register-page-container">
      <div className="register-page-card">
        <div className="register-page-header">
          <h2 className="register-page-logo">
            <img src={tanuragalogo} className='loginpagelogo' alt="Tanuraga Logo" />
          </h2>
          <p className="register-page-tagline">Submit OTP</p>
        </div>

        <form className="login-page-form" onSubmit={handleSubmit}>
          <div className="register-page-form-group">
            <label htmlFor="otp" className="register-page-label">OTP Code</label>
            <input
              type="text"
              id="otp"
              className="register-page-input"
              placeholder="Enter OTP from email"
              value={otp}
              maxLength={6}
              onChange={(t) => setotp(t.target.value.replace(/\D/g, ""))}
              required
            />
          </div>

          <button type="submit" className="register-page-button">
            {
              showloding ?
              <Spinner color='#fff' size={15} className='spinnerCenter' /> :
              "Verify OTP"
            }
          </button>
        </form>

        <p className="register-page-separator">Or</p>
        <p className="register-page-footer">
          Need a new OTP? <Link to={'/forgot-password'} className="register-page-link">Send again</Link>
        </p>
      </div>
    </div>
  );
};

export default SubmitOtpPage;
